import React, { useMemo, useState } from 'react';
import { Chip, ThemeProvider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { PopUpIcon } from '../../Icons';
import { validationMessages } from '../../../../utils/constants';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';
import classes from '../scss/addEditFormModal.module.scss';
import { addToIndustries, theme } from '../helpers/helpers';
import colors from '../../../../scss/colors';

function IndustriesForm(props) {
  const { addEditForm } = props;

  const industries = useSelector((state) => state.constFromApi.industries);
  const [valuesToAdd, setValuesToAdd] = useState([]);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const validationMessage = useMemo(() => validationMessages(t), [t]);

  let formIndustries = [];
  const initialItems = addEditForm.values?.industries?.map((industry) => ({
    value: industry.Industry.Name,
    IndustryId: industry.Industry.Id
  }));

  formIndustries = addToIndustries(initialItems, formIndustries);

  const addHandler = (data) => {
    let changedFormIndustries = [];
    changedFormIndustries = addToIndustries(data, changedFormIndustries);
    setValuesToAdd([]);
    const allAddedIndustries = addEditForm.values?.industries.concat(changedFormIndustries);
    addEditForm.setFieldValue('industries', allAddedIndustries);
  };

  return (
    <>
      <span className={`${classes.constantText} mt-2`}>{t('common.forms.labels.industry')}</span>
      {!addEditForm.values.industries?.length && <ValidationErrorLabel message={validationMessage.INDUSTRY_REQ} />}
            <div className="flex flex-row">
        <div className="flex flex-col w-full">
          <Autocomplete
            multiple
            disableCloseOnSelect
            disablePortal
            value={valuesToAdd}
            open={open}
            options={industries.slice(1, industries.length)}
            getOptionLabel={(option) => option.label.toString()}
            popupIcon={<PopUpIcon />}
            renderOption={(params, option) => {
              return (
                !addEditForm.values.industries.some((opt) => opt.Industry.Id === option.IndustryId) && (
                  <li {...params} className="cursor-pointer hover:bg-gray-200 d-flex justify-content-between align-items-center ms-3 me-1  py-2">
                    {option.label}
                  </li>
                )
              );
            }}
            onChange={(event, value) => {
              setValuesToAdd(value);
              addHandler(value);
            }}
            renderInput={(params) => (
              <div className={classes.autocompleteInput}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <TextField
                  {...params}
                  label="Add Industry"
                  variant="outlined"
                  onFocus={() => setOpen(true)}
                  onBlur={() => setOpen(false)}
                  onClick={() => setOpen(true)}
                  onInput={() => setOpen(true)}
                  fullWidth
                  sx={{
                    marginBottom: '30px'
                  }}
                />
              </div>
            )}
          />
        </div>
      </div>
      <div className={`${classes.skillsList} mb-2 flex flex-col w-full border-b-1 border-gray-200 pb-6`}>
        {addEditForm.values?.industries?.map((item) => (
          <ThemeProvider key={item.Industry.Id} theme={theme}>
            <Chip
              className={classes.chip}
              label={item.Industry.Name}
              deleteIcon={<CloseIcon fontSize="small" color="warning" />}
              color="primary"
              variant="filled"
              onDelete={() =>
                addEditForm.setFieldValue(
                  'industries',
                  addEditForm.values?.industries.filter((industry) => industry.Industry.Id !== item.Industry.Id),
                  true
                )
              }
              sx={{ color: colors.WHITE, fontSize: '14px' }}
            />
          </ThemeProvider>
        ))}
      </div>
    </>
  );
}

export default IndustriesForm;
